define('service__number_translate',['bootstrap'], function (news) {

    function convertNumbers (vocab, number) {
        return vocab.worldServiceNumbers[number];
    }

    function rtlProgressIndexFormat (vocab, number, outOf, separator) {
        return convertNumbers(vocab, outOf) + ' ' + separator + ' ' + convertNumbers(vocab, number);
    }

    var numberFormatDictionary = {

        defaultNumberFormat: function (vocab, number, outOf, separator) {
            return '(' + convertNumbers(vocab, number) + ') ' + separator + ' (' + convertNumbers(vocab, outOf) + ')';
        },

        news: function (vocab, number, outOf, separator) {
            return number + separator + outOf;
        },

        persian: function (vocab, number, outOf, separator) {
            return '(' + convertNumbers(vocab, outOf) + ') ' + separator + ' (' + convertNumbers(vocab, number) + ')';
        },

        arabic: rtlProgressIndexFormat,

        pashto: rtlProgressIndexFormat,

        urdu:   rtlProgressIndexFormat
    };

    return {
        translate: function (vocab, number, outOf, separator) {
            var functionToCall          = numberFormatDictionary['defaultNumberFormat'],
                serviceSpecificFunction = numberFormatDictionary[vocab.service];

            if (typeof serviceSpecificFunction !== 'undefined') {
                functionToCall = serviceSpecificFunction;
            }

            separator = (typeof separator === 'undefined') ? '/' : separator;

            return functionToCall(vocab, number, outOf, separator);
        }
    };

});
